import { twc } from 'react-twc';

import { cn } from '@/utils/twx';

import { CommonButton, CommonButtonProps } from './CommonButton';

const BaseOutlinedButton = twc(CommonButton)`
${cn(
  'border bg-transparent',
  'hover:bg-opacity-10 transition-all',
  'disabled:bg-transparent disabled:cursor-not-allowed disabled:hover:bg-transparent',
)}
`;
const PrimaryOutlinedButton = twc(BaseOutlinedButton)`border-primary text-primary`;

const SecondaryOutlinedButton = twc(BaseOutlinedButton)`border-secondary text-secondary`;

const ErrorOutlinedButton = twc(BaseOutlinedButton)`border-error text-error`;

const GrayOutlinedButton = twc(BaseOutlinedButton)`border-gray-5 `;

const OutlinedButton = ({ color, ...props }: CommonButtonProps) => {
  switch (color) {
    case 'primary':
      return <PrimaryOutlinedButton {...props} />;
    case 'secondary':
      return <SecondaryOutlinedButton {...props} />;
    case 'gray':
      return <GrayOutlinedButton {...props} />;
    case 'error':
      return <ErrorOutlinedButton {...props} />;
    default:
      return <BaseOutlinedButton {...props} />;
  }
};
export default OutlinedButton;
